import { EmailAccountDomainRecord } from "@jugl-web/rest-api";
import { TableGrid } from "@jugl-web/ui-kit";
import React, { useMemo } from "react";
import { useDomainRecordsTableColumns } from "./hooks/useDomainRecordsTableColumns";
import { DomainRecordsTableRowData } from "./types";

export const DomainRecordsTable: React.FC<{
  records: EmailAccountDomainRecord[];
}> = ({ records }) => {
  const columns = useDomainRecordsTableColumns();

  const data = useMemo<DomainRecordsTableRowData[]>(
    () =>
      records.map((record, index) => ({
        ...record,
        id: `${record.name}-${index}`,
      })),
    [records]
  );

  return (
    <div className="overflow-hidden rounded-xl border border-solid border-[#EEF2F5]">
      <TableGrid
        id="email-domain-records"
        variant="grid"
        inline
        data={data}
        columns={columns}
        classNames={{
          wrapper: "overflow-x-hidden",
          bodyCell: "min-w-0",
        }}
      />
    </div>
  );
};
